import { motion } from 'framer-motion'
import React from 'react'

import { About } from '../../components/About'
import { Feed } from '../../components/Feed'
import { Contact } from '../../components/Contact'

export const Home = () => {
    return (
        <React.Fragment>
            <About />
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
            >
                <Feed />
            </motion.div>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
            >
                <Contact />
            </motion.div>
        </React.Fragment>
    )
}